import beatriceLogo from "../../assets/images/beatriceLogo.png";
import useHomeStore from "../../store/homeStore";


const Footer = () => {

  const currentyear = new Date().getFullYear();
  const homePageLinks = useHomeStore((state)=> state.HomePageLinks);
  return (
    <footer className="col-md-12 new-footer emailFooter">
      <div style={{ paddingInline: "2%" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>

          <div className="footer-links">
            <div>
              <a href={homePageLinks.aboutLink || "/"} target="_blank" rel="noreferrer">
                About
              </a>
            </div>
            <div>
              <a href={homePageLinks.servicesLink || "/"} target="_blank" rel="noreferrer">
                Services
              </a>
            </div>
            <div>
              <a href={homePageLinks.newsLink || "/"} target="_blank" rel="noreferrer">
                News
              </a>
            </div>
            <div>
              <a href={homePageLinks.contactLink || "/"} target="_blank" rel="noreferrer">
                Contact Us
              </a>
            </div>
          </div>

          <div>
            <a href={homePageLinks.clientLink || "/"} target="_blank" rel="noreferrer">
              <img src={beatriceLogo} className="logo-icon" alt="logo" />
            </a>
          </div>
        </div>

        <div className="footer-legal-div">
          <div className="link-div">
            <a
              className="text-link-legal"
              href={homePageLinks.termsLink || "/"}
              target="_blank"
              rel="noreferrer"
            >
              Terms of Service
            </a>

            <a
              className="text-link-legal"
              href={homePageLinks.privacyLink || "/"}
              target="_blank"
              rel="noreferrer"
            >
              Privacy Policy
            </a>

            <a
              className="text-link-legal"
              href={homePageLinks.accesibilityStatementLink || "/"}
              target="_blank"
              rel="noreferrer"
            >
              Accessibility Statement
            </a>
          </div>
        </div>

        <div>
          <a className="text-link-legal" href="/">
            © {currentyear} Beatrice Advisors LP.
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
